// extracted by mini-css-extract-plugin
export default {"up":"MiscCheckMarksValues_up__sNOdm","down":"MiscCheckMarksValues_down__1DPRG","btnSubmit":"MiscCheckMarksValues_btnSubmit__Ucyn5"};